export default __webpack_public_path__ + "static/media/how-it-works--mobile.1170ee6b.webp";